import { useNavigate } from 'react-router-dom'
import * as qs from 'query-string'
import { QueryParams } from '../Sections/EmailSection/interfaces'

type UseSuccessLoginNavigationArgs = {
	privacyChecked: boolean
}

interface OauthParamsInterface {
	oauthRedirect?: string
	qrCode?: string
}

interface WhiteboardMacParamInterface extends OauthParamsInterface {
	scheme?: string
	qt?: string
}

interface WhiteboardDefaultParamInterface extends OauthParamsInterface {
	code?: string
	qt?: string
}

export const useSuccessLoginNavigation = ({ privacyChecked }: UseSuccessLoginNavigationArgs): (() => void) => {
	const navigate = useNavigate()

	return (): void => {
		const queryParams = qs.parse(location.search) as unknown as WhiteboardMacParamInterface | WhiteboardDefaultParamInterface
		const { qt, oauthRedirect, qrCode } = queryParams
		const isWhiteboardLogin = Boolean(qt)
		const defaultParams = { rememberMe: !privacyChecked }

		if (oauthRedirect) {
			const params = qs.stringify({ ...defaultParams, oauthRedirect, qr: true })
			navigate(`/authenticated?${params}`)
			return
		}

		if (isWhiteboardLogin) {
			const scheme = 'scheme' in queryParams ? queryParams.scheme : undefined
			const code = 'code' in queryParams ? queryParams.code : undefined
			const params = qs.stringify({ ...defaultParams, scheme, code, qr: true })
			navigate(`/authenticated?${params}`)
			return
		}

		if (qrCode) {
			const qrParams = qs.stringify({ ...defaultParams, qrCode, remote: true })
			navigate(`/authenticated?${qrParams}`)
		}
	}
}
